// Minimal bootstrap file with careful module loading order
// console.log('[BOOTSTRAP] Application bootstrap starting');

// Step 1: Import core React dependencies only
import React from 'react';
import ReactDOM from 'react-dom/client';

// Step 2: Basic CSS only for initial rendering
import './styles/global.css';

// Step 3: Import App component directly
import App from './App';
import './index.css';
import { AppThemeProvider } from './contexts/ThemeContext';

// Add error handling for React initialization
try {
  // console.log("[INIT] index.tsx initializing...");
  
  // Get the root element
  const rootElement = document.getElementById('root');
  
  if (!rootElement) {
    throw new Error('Failed to find the root element');
  }
  
  // Create a root
  const root = ReactDOM.createRoot(rootElement);
  
  // Render the app with proper providers
  root.render(
    <React.StrictMode>
      <AppThemeProvider>
        <App />
      </AppThemeProvider>
    </React.StrictMode>
  );
  
  // console.log("[INIT] App successfully rendered");
} catch (error) {
  console.error('[FATAL] Failed to initialize React application:', error);
  // Display error to user
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="color: #721c24; background-color: #f8d7da; padding: 20px; border-radius: 5px;">
        <h2>Application Error</h2>
        <p>The application failed to initialize: ${error instanceof Error ? error.message : 'Unknown error'}</p>
        <button onclick="window.location.reload()" style="margin-top: 10px; padding: 8px 16px; background-color: #721c24; color: white; border: none; border-radius: 4px; cursor: pointer;">
          Reload Application
        </button>
      </div>
    `;
  }
}

